import {
  GLOBAL_DESIGN_ERROR_PREFIX,
  GLOBAL_DESIGN_INFO_PREFIX,
} from '../../../../apis/services/editActionsServices/nativeActions/globalDesign/constants';
import { LeadingStyleGroup, StyleValues } from '../../types';

import { CompRef } from '@wix/document-services-types';
import type { EditorPointer } from '@wix/editor-document-logic-api';

type LeadingGroupInfo = {
  editorPointerKey: string;
  styleItemsIds: string[];
  styleNamespace: string;
  values: Record<string, string>;
  subsetGroups: SubsetGroupInfo[];
};

type SubsetGroupInfo = Omit<LeadingGroupInfo, 'subsetGroups'>;
class GlobalDesignPanelLogger {
  static logGlobalDesignGroups(leadingGroups: LeadingStyleGroup[]) {
    const formattedData: LeadingGroupInfo[] = [];

    for (const group of leadingGroups) {
      const info: LeadingGroupInfo = {
        editorPointerKey: group.editorPointer.asUniqueKey,
        styleItemsIds: [],
        styleNamespace: group.styleNamespace,
        values: {},
        subsetGroups: [],
      };

      info.styleItemsIds = group.items.map((item) => item.styleItemId);

      info.values = group.context.query.getStyles()[group.styleNamespace];

      for (const subsetGroup of group.subsetGroups) {
        const groupInfo: SubsetGroupInfo = {
          editorPointerKey: subsetGroup.editorPointer.asUniqueKey,
          styleItemsIds: subsetGroup.items.map((item) => item.styleItemId),
          styleNamespace: subsetGroup.styleNamespace,
          values:
            subsetGroup.context.query.getStyles()[subsetGroup.styleNamespace],
        };

        info.subsetGroups.push(groupInfo);
      }

      formattedData.push(info);
    }

    console.info(GLOBAL_DESIGN_INFO_PREFIX + 'GROUPS DATA', formattedData);
  }

  static logChanges(
    changes: {
      isFailed: boolean;
      editorPointer: EditorPointer<CompRef>;
      styleValues: StyleValues;
    }[],
  ) {
    const failedChanges: Record<string, StyleValues> = {};
    const successfulChanges: Record<string, StyleValues> = {};

    for (const change of changes) {
      if (change.isFailed) {
        failedChanges[change.editorPointer.asUniqueKey] = change.styleValues;
      } else {
        successfulChanges[change.editorPointer.asUniqueKey] =
          change.styleValues;
      }
    }

    if (Object.keys(failedChanges).length > 0) {
      console.error(
        GLOBAL_DESIGN_ERROR_PREFIX + 'FAILED MERGED CHANGES',
        failedChanges,
      );
    }

    if (Object.keys(successfulChanges).length > 0) {
      console.info(
        GLOBAL_DESIGN_INFO_PREFIX + 'SUCCESSFUL MERGED CHANGES',
        successfulChanges,
      );
    }
  }
}

export default GlobalDesignPanelLogger;
